var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 506 404",
    width: 22,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M506.2 50.9c-18.6 7.8-38.5 13-59.3 15.1 21.5-12.3 38.1-32.2 46.2-56-20.1 11.4-42.2 19.6-65.7 23.8C409.1 13.5 382.6.5 353 0c-56.7-1-103.5 44.2-104.5 101-.1 8.1.6 15.9 2.2 23.4-85.3-5.8-160.3-48-209.9-111C31.7 28.4 26.4 46 26 64.8c-.6 35.6 17 67.4 44.2 86.3-16.8-.8-32.6-5.8-46.3-13.6v1.3c-.9 49.8 33.8 91.9 80.7 102.2-8.7 2.2-17.7 3.3-27.1 3.1-6.6-.1-13-.9-19.3-2.2 12.4 41 49.8 71.4 94.7 73-35.6 27-80.3 42.6-128.4 41.8-8.3-.1-16.5-.8-24.5-1.9 45 29.9 98.7 47.9 156.7 48.9 189 3.3 295.1-151.4 297.4-287.2.1-4.5.1-8.9 0-13.3 20.3-14.2 38.1-32 52.1-52.3"
  })));
};
export default SvgTwitter;